import { render, staticRenderFns } from "./AuthResetPasswordForm.vue?vue&type=template&id=4a6fa1b8&scoped=true"
import script from "./AuthResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./AuthResetPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./AuthResetPasswordForm.vue?vue&type=style&index=0&id=4a6fa1b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6fa1b8",
  null
  
)

export default component.exports